<template>
  <WdsAvatar :path="path" />
</template>

<script setup lang="ts">
import { WdsAvatar } from '@worksome/wds-components'
import { useAvatarPath } from '@/composables/useAvatarPath'

const props = defineProps<{
  avatar?: string | null
  id: string | number
}>()

const path = useAvatarPath(
  () => props.avatar,
  () => props.id,
)
</script>
